export interface InsureEnvironment {
  production: boolean;
  ApiBaseUrl: string;
  RecaptchaSiteKey: string;
  passwordMinLength: number;
  userInactivityMinutes: number;
  userInactivityResponseSeconds: number;
  EnableQuoteFeature: boolean;
  EnableCustomerPortal: boolean;
}

export const environmentBase: InsureEnvironment = {
  production: false,
  ApiBaseUrl: '/api-dev',
  RecaptchaSiteKey: '6LdVqG4gAAAAABPTSIocqqnK14DyV72U8ieKjRpN',
  passwordMinLength: 12,
  userInactivityMinutes: 15,
  userInactivityResponseSeconds: 30,
  EnableQuoteFeature: true,
  EnableCustomerPortal: false,
};
